/**
 * Review-grid Excel sheets. A flagged cell carries the grid's severity as a
 * fill: red for an error (m), yellow for a warning (q). Info notes and
 * annotations the user dismissed stay unfilled, as they stay untinted in the grid.
 *
 * Fills need a styles-aware writer: SheetJS community `xlsx` drops `cell.s`, so
 * the export passes `xlsx-js-style` (the same SheetJS API with styles).
 */
export const ISSUE_FILL_RGB = { m: 'FF0000', q: 'FFFF00' };

/** Most severe of an annotation and the issues stacked under it: 'm', 'q' or null. */
export function issueFillType(ann) {
  if (!ann) return null;
  const types = [ann.type, ...(ann.extra || []).map((e) => e?.type)];
  if (types.includes('m')) return 'm';
  if (types.includes('q')) return 'q';
  return null;
}

/**
 * One column group as a worksheet: the Ad group name first, so each tab reads
 * standalone, then the group's columns. `annotationOf(row, field)` returns the
 * cell's live annotation (null when absent or dismissed).
 */
export function buildReviewGroupSheet(XLSX, { cols, rows, getRowValue, annotationOf }) {
  const fields = ['name', ...cols.map((c) => c.k)];
  const aoa = [['Ad group', ...cols.map((c) => c.l || c.k)]];
  for (const row of rows) {
    aoa.push(fields.map((f) => {
      const v = getRowValue(row, f);
      return v == null ? '' : v;
    }));
  }
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  rows.forEach((row, r) => fields.forEach((field, c) => {
    const type = issueFillType(annotationOf(row, field));
    if (!type) return;
    const ref = XLSX.utils.encode_cell({ r: r + 1, c });
    ws[ref] = {
      ...(ws[ref] || { t: 's', v: '' }),
      s: { fill: { patternType: 'solid', fgColor: { rgb: ISSUE_FILL_RGB[type] } } },
    };
  }));
  ws['!cols'] = [{ wch: 40 }, ...cols.map((c) => ({ wch: Math.max(12, Math.round((c.w || 120) / 7)) }))];
  return ws;
}
